/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import { useState } from 'react';

const due = (n) => String(n).padStart(2, '0');
export const perCampoData = (d) => `${d.getFullYear()}-${due(d.getMonth() + 1)}-${due(d.getDate())}`;
export const perCampoOra = (d) => `${due(d.getHours())}:${due(d.getMinutes())}`;

const UN_GIORNO = 24 * 3600;

// Gestisce data, ora e pausa della fine di una sessione di lavoro.
//
// La fine è un istante scelto per intero: data + ora. Prima si prendeva solo
// l'orario e lo si applicava alla data di INIZIO, aggiungendo al massimo un giorno:
// una sessione più lunga di 24 ore veniva registrata troncata, e con una data di fine
// nel passato, senza nessun avviso. Il campo data resta nascosto finché non serve,
// così la chiusura di tutti i giorni non cambia.
export function useFineSessione(inizio) {
  const adesso = new Date();
  const [fineData, setFineData] = useState(perCampoData(adesso));
  const [fineOra, setFineOra] = useState(perCampoOra(adesso));
  const [pausa, setPausa] = useState(0);

  const inizioDate = new Date(inizio);
  const fine = new Date(`${fineData}T${fineOra}`);
  const valida = !isNaN(fine.getTime());

  const durataTimer = Math.max(0, Math.floor((Date.now() - inizioDate.getTime()) / 1000));
  const oltreUnGiorno = durataTimer >= UN_GIORNO;

  const primaDellInizio = valida && fine.getTime() <= inizioDate.getTime();
  const nelFuturo = valida && fine.getTime() > Date.now() + 60 * 1000;

  const minutiPausa = parseInt(pausa, 10) || 0;
  const secondiStimati = valida && !primaDellInizio
    ? Math.max(0, Math.round((fine - inizioDate) / 1000) - minutiPausa * 60)
    : 0;

  // Il campo data compare solo quando serve davvero: sessione oltre le 24 ore,
  // oppure fine in un giorno diverso da quello di inizio.
  const mostraData = oltreUnGiorno || perCampoData(inizioDate) !== fineData;

  return {
    fineData, setFineData,
    fineOra, setFineOra,
    pausa, setPausa, minutiPausa,
    fine, valida, mostraData, oltreUnGiorno,
    primaDellInizio, nelFuturo, secondiStimati, durataTimer,
    puoSalvare: valida && !primaDellInizio && !nelFuturo,
  };
}
